module.exports = __webpack_public_path__ + "static/media/logo.24ff8fe7.png";